import React, { useCallback, useContext } from "react";
import { useFormValidity } from "../../../../components/form/MultiFormContext";
import { ScrollPositionContext } from "../../../../components/scrollPosition/ScrollPositionContext";
import { InvoiceType, Validity } from "../../../../data/models/ContractTypes";
import { includeInvoicing, LinkAnchors } from "../ContractEdit";
import { ContractEditMenuItem } from "./ContractEditMenuItem";
import "./ContractEditMenu.scss";
import { contractSidebarState } from "../../../../state/uiState";
import { useAtomValue, useSetAtom } from "jotai";
import { contractInvoiceState } from "../../../../state/contractInvoiceState";
import { useContract } from "../../../../hooks/useContract";

export enum FormName {
  PRIMARY_CONTACT = "primary-contact",
  MAIN_DATA = "main-data",
  SALES_DATA = "sales-data",
  FINANCIAL_ESTIMATES = "financial-estimates",
  INVOICE_EMAIL = "invoice-email",
  INVOICE_ADDRESS = "invoice-address",
  FINANCIAL_DATA = "financial-data",
  OFFERING = "offering",
  STORE = "store",
  UPLOADS = "uploads",
  NOTES = "notes",
}

export const ContractEditMenu: React.FunctionComponent = () => {
  const toggleMenu = useSetAtom(contractSidebarState);
  const contract = useContract();
  const isPrimaryValid = useFormValidity(FormName.PRIMARY_CONTACT);
  const isMainDataValid = useFormValidity(FormName.MAIN_DATA);
  const isFinancialEstimatesValid = useFormValidity(
    FormName.FINANCIAL_ESTIMATES
  );
  const invoices = useAtomValue(contractInvoiceState);
  const isInvoiceEmailValid = useFormValidity(FormName.INVOICE_EMAIL);
  const isInvoiceAddressValid = useFormValidity(FormName.INVOICE_ADDRESS);
  const isFinancialDataValid = useFormValidity(FormName.FINANCIAL_DATA);
  const isSalesDataValid = useFormValidity(FormName.SALES_DATA);
  const isStoreValid = useFormValidity(FormName.STORE);
  const isOfferingValid = useFormValidity(FormName.OFFERING);
  // const isPricingValid = useFormValidity(FormName.PRICING);
  const scrollPositionContext = useContext(ScrollPositionContext);

  const scrollPosition = scrollPositionContext?.closestScrollEntry;

  const onClick = useCallback(
    (id: string) => {
      const element = document.getElementById(id);

      if (!element) {
        return;
      }

      const offset = 160;
      const elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      toggleMenu(false);
    },
    [toggleMenu]
  );

  return (
    <div className="contract-edit-vertical-menu">
      <div className="contract-edit-menu-links">
        <ul>
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.PRIMARY_CONTACT}
            validity={isPrimaryValid}
            active={
              scrollPosition?.id === LinkAnchors.PRIMARY_CONTACT.anchor ||
              typeof scrollPosition?.id === "undefined"
            }
          />
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.COMPANY_DATA}
            validity={isMainDataValid}
            active={scrollPosition?.id === LinkAnchors.COMPANY_DATA.anchor}
          />
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.FINANCIAL_DATA}
            validity={isFinancialDataValid}
            active={scrollPosition?.id === LinkAnchors.FINANCIAL_DATA.anchor}
          />
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.FINANCIAL_ESTIMATES}
            validity={isFinancialEstimatesValid}
            active={
              scrollPosition?.id === LinkAnchors.FINANCIAL_ESTIMATES.anchor
            }
          />

          {includeInvoicing(contract) && (
            <ContractEditMenuItem
              onClick={onClick}
              anchor={LinkAnchors.INVOICING}
              validity={
                invoices.invoiceType === undefined
                  ? Validity.PARTIAL
                  : invoices.invoiceType === InvoiceType.EMAIL
                  ? isInvoiceEmailValid
                  : isInvoiceAddressValid
              }
              active={scrollPosition?.id === LinkAnchors.INVOICING.anchor}
            />
          )}
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.SALES_DATA}
            validity={isSalesDataValid}
            active={scrollPosition?.id === LinkAnchors.SALES_DATA.anchor}
          />
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.OFFERING}
            validity={isOfferingValid}
            active={scrollPosition?.id === LinkAnchors.OFFERING.anchor}
          />
          {/* <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.PRICING}
            validity={isPricingValid}
            active={scrollPosition?.id === LinkAnchors.PRICING.anchor}
          /> */}
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.STORES}
            validity={isStoreValid}
            active={scrollPosition?.id === LinkAnchors.STORES.anchor}
          />
          <ContractEditMenuItem
            onClick={onClick}
            anchor={LinkAnchors.UPLOADS}
            validity={Validity.VALID}
            active={scrollPosition?.id === LinkAnchors.UPLOADS.anchor}
          />
        </ul>
      </div>
    </div>
  );
};
